import { useMemo, useState, useEffect } from 'react';
import { LineChart, Line, ResponsiveContainer, YAxis, Tooltip } from 'recharts';
import { getRankColor } from '@/utils/rankUtils';

export default function TrendSparkline({ data }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Delay render to ensure container is mounted with proper dimensions
    const timer = setTimeout(() => setIsReady(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const chartData = useMemo(() => {
    return data.map(d => ({
      rank: d.rank,
      date: new Date(d.scanned_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    }));
  }, [data]);

  const latestRank = data[data.length - 1]?.rank;
  const strokeColor = getRankColor(latestRank);

  if (chartData.length < 2 || !isReady) return null;

  return (
    <ResponsiveContainer width="100%" height={48} debounce={50}>
      <LineChart data={chartData} margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
        <YAxis 
          domain={[1, 20]} 
          reversed={true} 
          hide 
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#131926',
            border: '1px solid #1E2D45',
            borderRadius: '8px',
            fontSize: '11px',
            fontFamily: 'JetBrains Mono, monospace',
          }}
          labelStyle={{ color: '#94A3B8' }}
          itemStyle={{ color: strokeColor }}
          formatter={(value) => [value !== null ? `Rank ${value}` : 'Not Ranked', '']}
          labelFormatter={(label) => label}
        />
        <Line
          type="monotone"
          dataKey="rank"
          stroke={strokeColor}
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 4, fill: strokeColor }}
          connectNulls={false}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
